import { render, staticRenderFns } from "./RmaPaymentBankAccount.vue?vue&type=template&id=3664cf90&scoped=true&"
import script from "./RmaPaymentBankAccount.vue?vue&type=script&lang=js&"
export * from "./RmaPaymentBankAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3664cf90",
  null
  
)

export default component.exports